import { render, staticRenderFns } from "./dept-add.vue?vue&type=template&id=a9b0a0a4&scoped=true&"
import script from "./dept-add.vue?vue&type=script&lang=js&"
export * from "./dept-add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=a9b0a0a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b0a0a4",
  null
  
)

component.options.__file = "dept-add.vue"
export default component.exports